import styled, { css } from "styled-components";
import { AlignmentHorizontalOption } from "@ecp-redux/dto/themeSettings/themeSettings.types";

export const StyledDropdownWrapper = styled.div(
  ({
    isOpen,
    forClient0,
    top,
    wrapperWidth,
    isDropdownWrapperWiderThanDropdownContent,
  }: {
    isOpen: boolean;
    forClient0: boolean;
    wrapperWidth: number | null;
    top: number | null;
    isDropdownWrapperWiderThanDropdownContent: boolean;
  }) => {
    const left = -Math.floor(wrapperWidth ?? 0);

    const styles = [
      css`
        width: 100%;
        z-index: var(--zindex-dropdown-wrapper);
      `,
    ];

    if (forClient0) {
      styles.push(css`
        padding: 3px 5px;
        border: 1px solid transparent;
        max-width: 420px;
        width: fit-content;
      `);

      if (isOpen) {
        if (!isDropdownWrapperWiderThanDropdownContent) {
          styles.push(css`
            border-radius: 10px 10px 0px 0px;
            border: 1px solid #dcdcdc;
            border-bottom: 1px solid transparent;
            height: calc(100% - 21px);
            right: 0;

            &::before {
              content: "";
              position: fixed;
              z-index: 10000;
              display: block;
              top: ${(top ?? 0) - 23}px;
              left: ${-left - 1}px;
              width: 23px;
              height: 24px;
              background-color: transparent;
              border: 1px solid #dcdcdc;
              border-radius: 50%;
              box-shadow: 0 0 0 10px white;
              clip-path: polygon(50% 50%, 0% 50%, 0% 100%, 50% 100%);
            }
          `);
        } else {
          styles.push(css`
            border: 1px solid #dcdcdc;
            border-radius: 10px 10px 0px 0px;
            border-bottom: 1px solid transparent;
          `);
        }
      }
    }

    return styles;
  }
);

export const StyledDropdownContent = styled.div<{
  wrapperWidth: number | null;
  left: number | null;
  top: number | null;
  openHorizontalDirection: AlignmentHorizontalOption;
  fixedWidth?: boolean;
  menuWrapperWidth?: number;
  menuWrapperPercentageWidth?: number;
  isOpen: boolean;
  forClient0: boolean;
  isDropdownWrapperWiderThanDropdownContent: boolean;
}>`
  position: absolute;
  z-index: var(--zindex-dropdown-content);

  ${({ wrapperWidth, openHorizontalDirection, fixedWidth }) =>
    openHorizontalDirection === AlignmentHorizontalOption.LEFT &&
    wrapperWidth &&
    !fixedWidth &&
    `width:${wrapperWidth}px`};

  ${({
    left,
    wrapperWidth,
    openHorizontalDirection,
    menuWrapperWidth,
    menuWrapperPercentageWidth,
  }) => {
    if (left === null || !wrapperWidth) return;

    if (menuWrapperWidth && menuWrapperPercentageWidth) {
      const offsetLeft =
        left -
        (menuWrapperWidth -
          (menuWrapperPercentageWidth / 100) * menuWrapperWidth);

      return `left: ${offsetLeft}px;`;
    }

    if (openHorizontalDirection === AlignmentHorizontalOption.CENTER) {
      return `
        left: ${left + wrapperWidth / 2}px;
        transform: translateX(-50%);
      `;
    }

    return openHorizontalDirection === AlignmentHorizontalOption.LEFT
      ? `right :${window.innerWidth - left - wrapperWidth}px`
      : `left :${left}px`;
  }};
  ${({ top }) => top !== null && `top:${top}px`};
  ${({ menuWrapperWidth, left }) =>
    menuWrapperWidth && `width: calc(${menuWrapperWidth}px - ${left}px)`};

  ${({
    wrapperWidth,
    forClient0,
    isDropdownWrapperWiderThanDropdownContent,
  }) => css`
    ${forClient0 && wrapperWidth && !isDropdownWrapperWiderThanDropdownContent
      ? css`
          &::before {
            content: "";
            position: absolute;
            top: -1px;
            width: ${wrapperWidth + 4}px;
            height: 3px;
            background-color: white;
          }

          &::after {
            content: "";
            position: absolute;
            top: 0;
            left: ${wrapperWidth + 4}px;
            width: 2px;
            height: 1px;
            background-color: white;
          }
        `
      : ""}
  `}

  ${({
    forClient0,
    isOpen,
    wrapperWidth,
    isDropdownWrapperWiderThanDropdownContent,
  }) =>
    forClient0 &&
    isOpen &&
    wrapperWidth &&
    isDropdownWrapperWiderThanDropdownContent
      ? css`
          > :first-child {
            border-radius: 0px 0px 10px 10px;
            border-top: 1px solid transparent;
            width: ${wrapperWidth}px;
          }
        `
      : ""}
`;

export const Wrapper = styled.div`
  top: 0px;
  right: 0px;
  width: 100%;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: var(--zindex-multimenu-content);
`;

export const BackDropElement = styled.div<{
  isMobile: boolean;
  backdropBlur?: number;
  backgroundColor?: string;
}>`
  ${({ isMobile }) => `position: ${isMobile ? "absolute" : "fixed"}`};
  ${({ backdropBlur }) =>
    backdropBlur && `backdrop-filter: blur(${backdropBlur}px)`};
  background-color: ${({ backgroundColor }) => backgroundColor};
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
`;
